import React from 'react';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import { compose } from 'ramda';
import { Loading } from '@fasstech/middle-design-system';
import SouscriptionPricingForm from './components/SouscriptionPricingForm.jsx';
import useGetSouscriptionPricingQuery from './hooks/useGetSouscriptionPricingQuery.js';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';

const SouscriptionPricing = ({ getMiddleText, viewMode }) => {
  const { getSouscriptionPricing, loading: loadingSouscriptionPricing } =
    useGetSouscriptionPricingQuery();

  if (loadingSouscriptionPricing) {
    return <Loading />;
  }

  return (
    <div>
      <SouscriptionPricingForm
        project={getSouscriptionPricing}
        getMiddleText={getMiddleText}
        viewMode={viewMode}
      />
    </div>
  );
};

export default compose(withGlobalData, withMiddleFeatures)(SouscriptionPricing);
